import { Component, OnInit, SimpleChanges } from '@angular/core';
import { LocalStorageService, MenuBreadCrumb, MessageService, params, SessionService } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { SubmenuComponent } from '../../modals/submenu/submenu.component';
import { AppComponent } from '../../../app.component'
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Module } from 'app/models2/administration/module';

@Component({
  selector: 'app-inital-page-mobile',
  templateUrl: './inital-page-mobile.component.html',
  styleUrls: ['./inital-page-mobile.component.scss']
})
export class InitalPageMobileComponent implements OnInit {

  public minimalScreen : number = environment.minimalScreen
  public notification : Array<Notification>
  constructor(
    private message: MessageService,
    public dialog: MatDialog,
    private session: SessionService,
    private appCompnent: AppComponent,
    private router: Router,
    private storage : LocalStorageService
  ) {
  }
  public menuBreadCrumb:Array<MenuBreadCrumb> = [{
    name:"Inicio",
    router:'/inicio',
    current:true
  }]
  public modules : Module[] = this.storage.get<Module[]>('modules')??[]

  ngOnChanges(changes: SimpleChanges) {
  }

  async ngOnInit() {
    if (this.session.getData('cargando') == true) {
      this.session.setData('cargando', false)
    }
    this.appCompnent.getNameCompany()
    this.message.closeLoading()
  }


  openDialog() {
    this.message.SuccessToast('Operación realizada correctamente')
  }

  openSubmenu(menu: Module): void {
    if(menu.route){
      this.router.navigate([menu.route])
      return
    }
        let size = screen.width > 500 ? 80 : 50
        if(screen.height > 800) size = 70

        if(menu.subModules.length < 3 && screen.width < 800) size = 40
        if(menu.subModules.length < 2 && screen.width < 800) size = 30


        const dialogRef = this.dialog.open(SubmenuComponent, {
          width: screen.height < 420 ? `${size}vw` : `${size}vh`,
          height: `${size}vh`,
          data: menu.subModules
        });
    }

}
